import { useEffect, useState } from "react";
import styles from "./styles/InputRadioMulti.module.css";
import { useTranslation } from "react-i18next";

const InputRadioMulti = ({
    options,
    value,
    inputId,
    handleChangeFunction,
    keyPrefix,
}) => {
    const [currentValue, setCurrentValue] = useState("");
    const { t } = useTranslation();

    useEffect(() => {
        setCurrentValue(value);
    }, [value]);

    return (
        <div className={`${styles.radio_buttons_conatianer}`}>
            {options.length > 0 &&
                options.map((option, idx) => (
                    <label
                        className={`${styles.radio_button}`}
                        key={`${keyPrefix}-${idx}`}
                    >
                        <input
                            type="radio"
                            name={inputId}
                            value={option}
                            checked={currentValue === option}
                            onChange={handleChangeFunction}
                        />
                        <span className={`${styles.radio_label}`}>
                            {t(option)}
                        </span>
                    </label>
                ))}
        </div>
    );
};

export default InputRadioMulti;
